import {
  AgxColumn,
  AgxRow,
  AgxEmptyState,
  Icon_Arrow,
  Icon_EditOutline,
  AgxTypography,
  AgxButton,
} from '@urbanx/agx.ui-components2';
import { processHtmlContent } from './CustomParagraphHelpers';
import { CustomEmailParagraph } from 'types/agencySettings';
import './CustomParagraphSection.scss';

interface CustomParagraphSectionProps {
  title: string;
  componentKey: string;
  customEmailParagraph?: CustomEmailParagraph;
  onAddCustomParagraph: () => void;
}

const CustomParagraphSection = ({
  title,
  componentKey,
  customEmailParagraph,
  onAddCustomParagraph,
}: CustomParagraphSectionProps) => {
  return (
    <div className="container100Percent alignItems" key={componentKey}>
      <AgxColumn gap="spacing-2xl" alignItems="stretch">
        <div className="borderBottomContainer">
          <AgxRow>
            <AgxTypography id="custom-paragraph-title" type="label" size="large">
              {title}
            </AgxTypography>
          </AgxRow>
        </div>
        {customEmailParagraph?.customParagraph ? (
          <AgxColumn id="customParagraphContainer" gap="spacing-md" alignItems="stretch">
            <AgxRow justifyContent="space-between">
              <AgxTypography id="custom-paragraph-label" type="label" size="medium">
                Custom Paragraph *
              </AgxTypography>
            </AgxRow>
            <div
              className="custom-paragraph-content"
              dangerouslySetInnerHTML={{
                __html: processHtmlContent(customEmailParagraph.customParagraph ?? ''),
              }}
            />
            <AgxRow>
              <AgxButton
                id="edit-custom-paragraph"
                text="Edit"
                variant="primary"
                size="small"
                onClick={onAddCustomParagraph}
                rightIcon={<Icon_EditOutline height={16} width={16} color="var(--text-white)" />}
              />
            </AgxRow>
          </AgxColumn>
        ) : (
          <AgxRow
            id="custom-paragraph-empty-state"
            fill
            justifyContent="center"
            alignItems="alignCenter"
          >
            <AgxEmptyState
              variant="advanced"
              label=""
              actionButtons={[
                {
                  isPrimary: true,
                  label: 'Add custom paragraph',
                  order: 1,
                  onClick: onAddCustomParagraph,
                  rightIcon: (
                    <Icon_Arrow
                      direction="right"
                      height={22}
                      width={22}
                      color="var(--text-white)"
                    />
                  ),
                },
              ]}
            />
          </AgxRow>
        )}
      </AgxColumn>
    </div>
  );
};

export default CustomParagraphSection;
